import { useQuery } from '@apollo/client'
import { GET_ALL_SUBPERSONS } from './operations'
import { AllSubpersons, AllSubpersonsVariables, UsersFilterInput } from '../../types'
import React from 'react'

interface Props {
  filter?: UsersFilterInput
  page?: number
  pageLength?: number
  skip?: boolean
}

const PAGE_LENGTH = 10

export const useAllSubpersons = ({ filter, page = 1, pageLength = PAGE_LENGTH }: Props = {}) => {
  const { emailOrNameLike, parentEmailOrNameLike } = filter || {}
  const queryVariables = React.useMemo<AllSubpersonsVariables>(
    () => ({
      filterData: {
        onlySubpersons: true,
        emailOrNameLike,
        parentEmailOrNameLike,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
      },
    }),
    [emailOrNameLike, parentEmailOrNameLike, page]
  )
  return useQuery<AllSubpersons, AllSubpersonsVariables>(GET_ALL_SUBPERSONS, {
    variables: queryVariables,
  })
}
